import React from "react";
import { useLocation } from "react-router-dom";

const HeroFeatured = () => {
  const location = useLocation();
  const { image, title, description } = location.state || {}; // Extract additional properties if provided

  return (
    <section className="px-4 py-6 mt-20">
      <div className="max-w-6xl mx-auto bg-white space-y-4 mt-8">
        <ul className="flex items-center list-none p-0 m-0">
          <li className="mr-2 text-sm lg:text-xl font-semibold font-poppins text-[#1a1a1a]">
            <a href="/home">Home</a>
          </li>
          <li className="mr-2 text-sm lg:text-xl font-semibold font-poppins text-[#1a1a1a]">
            &gt;
          </li>
          <li className="mr-2 text-sm lg:text-xl font-semibold font-poppins text-[#1a1a1a]">
            Featured Hero
          </li>
        </ul>

        {/* Main Content Container: Image + Information */}
        <div className="flex flex-col lg:flex-row lg:mt-10 space-y-6 lg:space-y-0 lg:space-x-6 items-center">
          {/* Image Section */}
          <div className="border border-gray-300 rounded-lg p-4 flex justify-center items-center lg:h-80 lg:w-80 h-[250px] w-[230px]">
            {image ? (
              <img
                src={image}
                alt="Hero Featured"
                className="max-w-full max-h-full object-contain"
              />
            ) : (
              <p className="text-center text-gray-500">No image available</p>
            )}
          </div>

          {/* Information Section */}
          <div className="px-4 lg:px-[90px] text-left">
            {/* Title */}
            <h2 className="text-lg sm:text-xl font-semibold mb-2">
              {title || "Featured Hero Title"}
            </h2>

            {/* Description */}
            <p className="text-base font-medium text-justify">
              {description ||
                "This is the default description for the featured hero section. Update the data passed to include specific details."}
            </p>

            {/* Add to Action Buttons */}
            <div className="flex flex-col lg:flex-row gap-4 mt-6">
              <button className="w-full lg:w-[250px] bg-[#162C2A] text-white py-3 rounded-xl hover:bg-green-900 transition-colors">
                Add to Cart
              </button>
              <button className="w-full lg:w-[250px] bg-[#162C2A] text-white py-3 rounded-xl hover:bg-green-900 transition-colors">
                Add to Wishlist
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroFeatured;
